import { terminologyConfig } from '../terminology/store';
const AppConfig = terminologyConfig({
    ResellerName : 'Customer',
    Clients : 'users',
    admins : '',
    Users  : '',
    sessions: '',
    caseManagement : 'Lead Management',
    casesection : '',
    casename: 'Lead',   
    witness: 'Discovery',
    deposition : 'Stocks',
    trail : 'Assists',
    mediation : 'Mutual Funds',
    arbiration : 'SIP',
    session : '',
    servicename : 'Lead',
    resellerclients : 'Team',
    member : 'Member',
    firstname : 'firstname'

    




}, {
"deposition": ["deposition", "singular", "{name}"],
  "witness": ["witnessPrep", "singular", "{name}"],
  "trail": ["trial", "singular", "{name}"],
  "mediation": ["mediation", "singular", "{name}"],
  "arbiration": ["arbitration", "singular", "{name}"],

  "ResellerName": [
    "reseller",
    "singular",
    "{name}"
  ],
  "Clients": [
    "client",
    "plural",
    "{name}"
  ],
  "admins": [
    "clientAdmin",
    "plural",
    "{name}"
  ],
  "Users": [
    "clientUser",
    "plural",
    "{name}"
  ],
  "sessions": [
    "businessSession",
    "plural",
    "{name}"
  ],
  "caseManagement": [
    "case",
    "singular",
    "{name} Management"
  ],
  "casesection": [
    "case",
    "singular",
    "{name}"
  ],
  "casename": [
    "case",
    "singular",
    "{name}"
  ],
  "session": [
    "businessSession",
    "singular",
    "{name}"
  ],
  "servicename": [
    "case",
    "singular",
    "{name}"
  ],
  "resellerclients": [
    "client",
    "plural",
    "{name}"
  ]
});

export default AppConfig;